export const BRAND_LOGO_SRC = '/Vaia_World_Logo_v3-removebg-preview.png'
export const BRAND_SITE_URL = 'https://vaia-travel.web.app'

export function getBrandLogoUrl(origin?: string) {
  const base =
    origin ||
    (typeof window !== 'undefined' ? window.location.origin : BRAND_SITE_URL)
  return `${base}${BRAND_LOGO_SRC}`
}

export function BrandLogo({
  className = 'h-14 w-auto',
  alt = 'VAIA World',
}: {
  className?: string
  alt?: string
}) {
  return <img src={BRAND_LOGO_SRC} alt={alt} className={`${className} object-contain`} />
}

export default function BrandMark({ className = 'w-[30px] h-[30px] shrink-0' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="none" stroke="#D98E2B" strokeWidth="4" />
      <path d="M50 20 L58 50 L50 80 L42 50 Z" fill="#1F4A34" />
      <circle cx="50" cy="50" r="4" fill="#D98E2B" />
    </svg>
  )
}

export function BrandName({ name }: { name?: string | null }) {
  const display = name?.trim() || 'VAIA WORLD'
  const vaiaMatch = display.match(/^(vai)(a)(\s.*)?$/i)

  if (vaiaMatch) {
    return (
      <div className="font-display font-bold text-[20px] text-forest leading-none">
        {vaiaMatch[1].toUpperCase()}
        <span className="text-vaia-amber">{vaiaMatch[2].toUpperCase()}</span>
        {vaiaMatch[3]?.toUpperCase()}
      </div>
    )
  }

  return (
    <div className="font-display font-bold text-[20px] text-forest leading-none">
      {display}
    </div>
  )
}
